module.exports = __webpack_public_path__ + "media/partners/reckitt-1567293e.svg";